export type PromptType = 'text' | 'image'

export type PromptReasoningLevel = 'low' | 'medium' | 'high'

export type AiPromptDefinitionResponseDTO = {
  id: string
  name: string
  activeVersion: number
}

export type AiTextPromptVersionResponseDTO = {
  id: string
  definitionId: string
  version: number
  fullText: string
  months: number
  reasoningLevel: PromptReasoningLevel
}

export type AiImagePromptVersionResponseDTO = {
  id: string
  definitionId: string
  version: number
  fullText: string
}

export type CreateTextDefinitionRequest = {
  name: string
  fullText: string
  months: number
  reasoningLevel: PromptReasoningLevel
}

export type CreateImageDefinitionRequest = {
  name: string
  fullText: string
}

export type UpdateDefinitionRequest = {
  activeVersion: number
}

export type CreateTextVersionRequest = {
  version: number
  fullText: string
  months: number
  reasoningLevel: PromptReasoningLevel
  setAsActive?: boolean
}

export type CreateImageVersionRequest = {
  version: number
  fullText: string
  setAsActive?: boolean
}

export type UpdateTextVersionRequest = {
  fullText: string
  months: number
  reasoningLevel: PromptReasoningLevel
  setAsActive?: boolean
}

export type UpdateImageVersionRequest = {
  fullText: string
  setAsActive?: boolean
}

export type AiPromptVersion = AiTextPromptVersionResponseDTO | AiImagePromptVersionResponseDTO

export const isTextVersion = (version: AiPromptVersion): version is AiTextPromptVersionResponseDTO => 'months' in version && 'reasoningLevel' in version
